import Joi from 'joi';

const maxMySqlTextColumnLength = 65535; // MySQL TEXT column size
const possiblyEmptyStringSchema = Joi.string().allow('');

export const vendorSchema = Joi.object({
  vendorContactOrganizationName: Joi.string().required().max(256),
  vendorContactFirstName: possiblyEmptyStringSchema.max(128),
  vendorContactLastName: possiblyEmptyStringSchema.max(128),
  vendorContactEmail: possiblyEmptyStringSchema.max(254),
  businessDescription: Joi.string().required().max(maxMySqlTextColumnLength),
  phoneNumber: possiblyEmptyStringSchema.max(64),
  addressLine1: possiblyEmptyStringSchema.max(256),
  addressLine2: possiblyEmptyStringSchema.max(256),
  addressLine3: possiblyEmptyStringSchema.max(256),
  addressLine4: possiblyEmptyStringSchema.max(256),
  city: possiblyEmptyStringSchema.max(128),
  region: possiblyEmptyStringSchema.max(128),
  country: possiblyEmptyStringSchema.max(128),
  postalCode: possiblyEmptyStringSchema.max(128),
  role: Joi.string().required().max(255),
  numEmployees: Joi.string().required().max(255),
});
